import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient,    private cookieService: CookieService,
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetUsers(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_get_users + '?filter=' + JSON.stringify(input);
    return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  updateLeadStatus(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_update_lead_status;
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}

